export function getDeviceType() {
  const ua = navigator.userAgent || navigator.vendor;

  const isIPadOS13OrLater = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;

  if (isIPadOS13OrLater || /iPad|Tablet/i.test(ua)) return "tablet";
  if (/iPhone|Android.*Mobile|Windows Phone/.test(ua)) return "mobile";

  if (/Android/.test(ua) && !/Mobile/.test(ua)) return "tablet";

  return "desktop";
}
